import { Component, Input } from '@angular/core';
import { Student } from '../../../../models/student.model';
import { StudentExtraInfo } from '../../../../models/student-extrainfo.model';

@Component({
    selector: 'app-student-detail-extra-info',
    templateUrl: './student-detail-extra-info.component.html',
    styleUrls: ['./student-detail-extra-info.component.scss']
})
export class StudentDetailExtraInfoComponent {

    @Input() student: Student;

    public getExtraInfoActive(studentExtraInfo: StudentExtraInfo) {

        return studentExtraInfo.active ? 'Sí' : 'No';

    }

}
